import { setDigitalData } from 'mf_core/adobe';
import { NavItem } from '@im/ui-lib/mf-utils';

const Search = {
  SEARCH_SUBMIT_SEARCH_NAVIGATION: 'Search Navigation',
  SEARCH_TYPE_PRODUCT_NAVIGATION: 'Product Navigation',
  SEARCH_TYPE_VENDOR_NAVIGATION: 'Vendor Navigation',
} as const;

export function handleInternalSearch(
  navItem: NavItem,
  searchReferrerPage: string | null,
  navTo: (item: NavItem) => void
) {
  let searchType = '';
  const searchTerm = navItem.label ?? '';

  const { route } = navItem;

  if (
    route?.includes('/product/productsearch') ||
    route?.includes('/product/subscriptioncategories') ||
    route?.includes('/product/subscriptiongroups') ||
    route?.includes('/product/subscriptionplan')
  ) {
    if (route?.includes('/product/productsearch')) {
      if (route?.includes('vendor=') || route?.includes('pageName=')) {
        searchType = Search.SEARCH_TYPE_VENDOR_NAVIGATION;
      } else {
        searchType = Search.SEARCH_TYPE_PRODUCT_NAVIGATION;
      }
    } else {
      searchType = Search.SEARCH_TYPE_PRODUCT_NAVIGATION;
    }

    setDigitalData({
      internalSearch: {
        searchReferrerPage,
        searchSubmit: Search.SEARCH_SUBMIT_SEARCH_NAVIGATION,
        searchTerm,
        searchType,
      },
    });
  }
  navTo(navItem);
}
